import Cookies from "js-cookie";

const getIdentifier = () => Cookies.get("internal_service_key");

export default getIdentifier;
